export const SYS_ADMIN = 'SYS_ADMIN';
export const TENANT_ADMIN = 'TENANT_ADMIN';
export const CUSTOMER_USER = 'CUSTOMER_USER';
